/*@ngInject*/
const BreadcrumbsMediator = function (breadcrumbsRepository) {

    this.loadSubmissionBreadcrumbs = function (submissionId) {
        return breadcrumbsRepository.loadSubmissionBreadcrumbs(submissionId);
    };

    this.loadQuoteBreadcrumbs = function (quoteId) {
        return breadcrumbsRepository.loadQuoteBreadcrumbs(quoteId);
    };

    this.loadReportBreadcrumbs = function (reportId) {
        return breadcrumbsRepository.loadReportBreadcrumbs(reportId);
    };

    this.loadPolicyIssuanceBreadcrumbs = function (policyIssuanceId) {
        return breadcrumbsRepository.loadPolicyIssuanceBreadcrumbs(policyIssuanceId);
    };

    this.loadProposalBreadcrumbs = function (proposalId) {
        return breadcrumbsRepository.loadProposalBreadcrumbs(proposalId);
    };

    this.loadPolicyCancellationBreadcrumbs = function (policyCancellationId) {
        return breadcrumbsRepository.loadPolicyCancellationBreadcrumbs(policyCancellationId);
    };

    this.loadEndorsementBreadcrumbs = function (endorsementId) {
        return breadcrumbsRepository.loadEndorsementBreadcrumbs(endorsementId);
    };

    this.loadPolicyBreadcrumbs = function (policyId) {
        return breadcrumbsRepository.loadPolicyBreadcrumbs(policyId);
    };

    this.loadPolicyRewriteBreadcrumbs = function (policyRewriteId) {
        return breadcrumbsRepository.loadPolicyRewriteBreadcrumbs(policyRewriteId);
    };
};

angular.module('gw-um-submission')
    .service('breadcrumbsMediator', BreadcrumbsMediator);
